window.crearPresupuesto = function (event) {
    event.preventDefault();
    cleanFeedback('crearPresupuesto', 'crearPresupuestoFormularioModal');

    let formData = new FormData(event.target);

    $.ajax({
        url:         urlPresupuesto,
        type:        'POST',
        data:        formData,
        processData: false,
        contentType: false,
        beforeSend:  function beforeSend() {
            $('#crearPresupuestoBotonEnviar').prop('disabled', true);
            $('#crearPresupuestoBotonEnviar').html("<i class=\"ri-loader-4-line ri-formatted spinner\"></i>".concat(transAccionProcesando));
        },
    })
     .done(function (response) {
         $('#crearPresupuestoFormularioModalCampoTitulo').val('');
         $('.sinResultadosPresupuestos').hide();
         pNotifySuccess(response.message);
         getPresupuestos(response.resource.id)
     })
     .fail(function (jqXHR, status, error) {
         showInvalidFeedback(jqXHR, 'crearPresupuesto', 'crearPresupuestoModal');
     })
     .always(function () {
         $("#crearPresupuestoBotonEnviar").prop('disabled', false);
         $("#crearPresupuestoBotonEnviar").html("<i class=\"ri-send-plane-2-fill ri-formatted\"></i> ".concat(transAccionCrearPresupuesto));
     });
}
